<div *ngIf="!isTeacher" class="confirmation-dialog">
  <div class="mb-3 d-flex justify-content-end"><img (click)="close()" class="cursor-pointer" src="assets/icons/close.svg" alt=""></div>
  <h1 *ngIf="!qnCompleted" class="text-24-600-133 text-c4 text-center">{{'Are you sure you want to quit?'| translate}}</h1>
  <h1 *ngIf="qnCompleted" class="text-24-600-133 text-c4 text-center">{{'All levels completed!'| translate}}</h1>
  <button (click)="close()" class="mt-4 primary-btn text-14-600-171 w-100">
    {{ isGame ? ('No, keep playing' | translate) : ('No, keep learning' | translate)}}
  </button>
  <button (click)="close(true)" class="mt-4 secondary-btn text-14-600-171 w-100">{{'Yes, end game' | translate}}</button>
</div>
<div *ngIf="isTeacher" class="confirmation-dialog">
  <div class="mb-3 d-flex justify-content-end"><img (click)="close()" class="cursor-pointer" src="assets/icons/close.svg" alt=""></div>
  <h1 *ngIf="!isStart" class="text-24-600-133 text-c4 text-center">{{'Are you sure you want to end quiz?'| translate}}</h1>
  <h1 *ngIf="isStart" class="text-24-600-133 text-c4 text-center">{{'Are you sure you want to start quiz?'| translate}}</h1>
  <button (click)="close()" class="mt-4 primary-btn text-14-600-171 w-100">
    {{ ('No, continue' | translate)}}
  </button>
  <button (click)="close(true)" class="mt-4 secondary-btn text-14-600-171 w-100">{{!isStart ? ('Yes, end quiz' | translate) : ('Yes, start quiz' | translate)}}</button>
</div>
